// @flow
import React, { useEffect } from 'react'

import { pathOr } from 'ramda'
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

import { DriftAnalytics } from '@driftt/dds.analytics'
import { connect, useSelector } from 'react-redux'

import { PrivateRoute } from 'utils/routing'
import { ThemeProvider, ToastProvider } from '@driftt/dds'
import { Div } from '@driftt/tide-core'

import SubNavigation from 'components/SubNavigation'
import Accounts from 'layouts/Accounts'
import Imports from 'layouts/Imports'
import GatedAccountsPage from 'pages/GatedAccountsPage'
import AccountsSegmentation from 'layouts/Segmentation'

import './style.css'

const mapStateToProps = state => ({
  isBot: state.user.bot,
  gates: state.user
})

const AppLayout = () => {
  const currentUser = useSelector((state) => pathOr(null, ['user'], state))
  useEffect(() => {
    if (!currentUser) {
      return
    }

    DriftAnalytics.initialize({ user: currentUser })
  }, [currentUser])

  return (
    <ThemeProvider>
      <ToastProvider>
        <Router basename="/accounts">
          <div className="accounts-layout__wrapper">
            <SubNavigation />
            <Div className="accounts-layout">
              <Switch>
                <PrivateRoute exact path="/" component={Accounts} />
                <PrivateRoute path="/imports" component={Imports} />
                <Route path="/gated" component={GatedAccountsPage} />
                <PrivateRoute
                  path="/segments/:segmentId"
                  requiredGate="ACCOUNTS_SEGMENTATION"
                  component={Accounts}
                />
                <PrivateRoute
                  path="/segments"
                  requiredGate="ACCOUNTS_SEGMENTATION"
                  component={AccountsSegmentation}
                />
              </Switch>
            </Div>
          </div>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  )
}

export default connect(mapStateToProps)(AppLayout)
